<template>
    <div class="bill_addon clr">
        <standart title="Рахунок" key="bill_addon" v-bind:is_active_result=false v-bind:is_active_problem=false></standart>
        <b-table :items="counterparty_items" :fields="counterparty_fields">
            <template v-slot:cell(remove_class)="row">
                <div class='icon-stack rem_doc' :class="{'disable' : can_dell}"
                     v-on:click="dell_counterparty(row.index)">
                    <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                    <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
                </div>
            </template>

			<template #cell(name)="row">
				<c_name :row=row.item></c_name>
			</template>

            <template #cell(edrpou)="row">
                <edrpou :row=row.item></edrpou>
            </template>
            

        </b-table>
        
        <div class="container-fluid">
            <b-button size="sm" variant="outline-info" @click="new_counterparty" class="">Додати</b-button>
        </div>
    </div>
</template>

<script>
import standart from '../standart.vue'
import edrpou from './advanced/edrpou'
import c_name from './advanced/c_name'

export default {
    name: "bill",
    components: {
        standart,
        edrpou,
        c_name
    },
    data() {
        return {
            counterparty_items: [{name: '', edrpou: '', valid: false}],
            counterparty_fields: [
				{
					key: 'name',
					label: 'Контрагент',
				},
                {
                    key: 'edrpou',
                    label: 'ЄДРПОУ',
                    sortable: true
                },
                {
                    key: 'remove_class',
                    label: '',
                    class: 'text-right fs-xxl cursor-pointer'
                },
            ],
            form: {
                counterparty_items: []
            },
        }
    },
    
    mounted() {
        setTimeout(() => EventBus.$emit('remove_dir'), 500);
    },
    
    watch: {
        edrpou_number: function (val) {
            this.check(val);
        }
    },
    
    computed: {
        return_data: function () {
            this.form.counterparty_items = this.counterparty_items;
            return this.form;
        },
        
        can_dell() {
            return this.counterparty_items.length == 1;
        },
    },
    methods: {
        
        new_counterparty() {
            this.counterparty_items.push({name: '', edrpou: '', valid: false})
        },
        
        dell_counterparty(index) {
            if (this.counterparty_items.length > 1) {
                this.counterparty_items.splice(index, 1)
            }
        },
    }
    
    
}

</script>

<style scoped>

</style>
